import React, {FC} from 'react';

import {Icon, Question} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './questionMark.scss';

type PropsType = {
    className?: string;
    color?:
        | 'blue'
        | 'white'
        | 'grey'
        | 'green'
        | 'transparentGrey'
        | 'transparentLimedSpruce'
        | 'primaryGrey'
        | 'dustSpruceGrey'
        | 'codGray'
        | 'regentGray';
    size?: 'small' | 'medium';
};

const colorClassNames = {
    blue: s.blue,
    codGray: s.codGray,
    dustSpruceGrey: s.dustSpruceGrey,
    green: s.green,
    grey: s.grey,
    primaryGrey: s.primaryGrey,
    regentGray: s.regentGray,
    transparentGrey: s.transparentGrey,
    transparentLimedSpruce: s.transparentLimedSpruce,
    white: s.white,
};

const sizeClassNames = {
    medium: s.medium,
    small: s.small,
};

/**
 * Question mark in blue circle
 * @returns {React.ReactNode} - Rendered icon
 */
export const QuestionMark: FC<PropsType> = ({
    className = '',
    color = 'blue',
    size = 'small',
    ...props
}) => (
    <span
        aria-label="Help"
        className={classNames(s.mark, className, colorClassNames[color], sizeClassNames[size])}
        data-test-name="questionMark"
        {...props}
    >
        <Icon className={s.helpIcon} icon={Question} size={size} />
    </span>
);
